import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import LogoImage from '../../assets/LogoFiverFlow.png';

export const Footer = () => {
  const columns = [
    {
      title: "Product",
      links: [
        { label: "Features", href: "#features", isScroll: true },
        { label: "Pricing", href: "#pricing", isScroll: true },
        { label: "Testimonials", href: "#testimonials", isScroll: true },
        { label: "FAQ", href: "#faq", isScroll: true },
        { label: "Docs", href: "/docs", isScroll: false }
      ]
    },
    {
      title: "Company",
      links: [
        { label: "About", href: "/about", isScroll: false },
        { label: "Work with us", href: "/work-with-us", isScroll: false },
        { label: "Contact", href: "/contact", isScroll: false }
      ]
    },
    {
      title: "Legal",
      links: [
        { label: "Terms", href: "/terms-of-service", isScroll: false },
        { label: "Privacy", href: "/privacy-policy", isScroll: false }
      ]
    }
  ];

  const handleScroll = (href: string) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="border-t border-white/10 py-12 mt-24">
      <div className="max-w-[1300px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/home" className="mb-4 inline-block">
              <img src={LogoImage} alt="FiverFlow Logo" className="h-6 w-auto" />
            </Link>
            <p className="text-sm text-neutral-500">
              Streamline your freelance workflow
            </p>
          </div>

          {/* Links Columns */}
          {columns.map((column, index) => (
            <motion.div
              key={column.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
                {column.title}
              </h4>
              <ul className="space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    {link.isScroll ? (
                      <a
                        href={link.href}
                        onClick={(e) => {
                          e.preventDefault();
                          handleScroll(link.href);
                        }}
                        className="text-sm text-neutral-500 hover:text-neutral-300 transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-neutral-500 hover:text-neutral-300 transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10">
          <p className="text-center text-sm text-neutral-500">
            © FiverFlow. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

